import React, { ReactElement } from 'react';
import { ReactComponent as DocumentIcon } from '@Icons/additional/document-gradient.svg';

import classNames from 'classnames';
import styles from './ActionButton.module.css';

interface ActionButtonProps {
  children?: ReactElement;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onClick?: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  Icon = DocumentIcon,
  onClick,
}) => {
  return (
    <div
      className={classNames(styles.button, 'trojan-neumorphism-box')}
      onClick={onClick}
    >
      {children}
      {Icon && <Icon />}
    </div>
  );
};

export default ActionButton;
